import Masker from 'vanilla-masker';

export default function (value) {
  if (!value) return value;
  return Masker.toNumber(value);
}
